import React from "react";
import TableOfContents from "../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./SpaCNotebook.css";
// import the separated file related to the component
import TextSpaCNotebook from "./TextSpaCNotebook.jsx";

const SpaCNotebook = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "Introduction",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "Intro-SpaC_s",
    },
    {
      level: 2,
      text: "Transformation SpaC",
      id: "Transformation1-SpaC_s",
    },
    {
      level: 2,
      text: "Primary Culture SpaC in BL21 and DH5α",
      id: "Primary1-SpaC_s",
    },
    {
      level: 2,
      text: "Glycerol Stock SpaC in BL21",
      id: "Glycerol1-SpaC_s",
    },
    {
      level: 2,
      text: "Miniprep of DH5α cells with SpaC",
      id: "Miniprep-SpaC_s",
    },
    {
      level: 2,
      text: "Glycerol Stock SpaC in DH5α",
      id: "Glycerol2-SpaC_s",
    },
    {
      level: 2,
      text: "Secondary culture SpaC in BL21",
      id: "Secondary1a-SpaC_s",
    },
    {
      level: 2,
      text: "Surface Expression Assay by GFP binding",
      id: "SurfaceExpression1-SpaC_s",
    },
    {
      level: 2,
      text: "Secondary culture SpaC in BL21 (IPTG induced)",
      id: "Secondary1b-SpaC_s",
    },
    {
      level: 2,
      text: "Western blot (expression check)",
      id: "Western1-SpaC_s",
    },
    {
      level: 2,
      text: "Proteinase K experiment SpaC",
      id: "ProteinaseK-SpaC_s",
    },
    {
      level: 2,
      text: "Surface Expression Assay by GFP binding",
      id: "SurfaceExpression2-SpaC_s",
    },
    {
      level: 2,
      text: "Half-life of SpaC",
      id: "Halflife1-SpaC_s",
    },
    {
      level: 2,
      text: "Secondary culture of BL21 containing SpaC",
      id: "Secondary3-SpaC_s",
    },
    {
      level: 2,
      text: "Sonication & Proteinase K assay",
      id: "Sonication-ProteinaseK-assay-SpaC_s",
    },
    {
      level: 2,
      text: "Immunofluorescence Assay",
      id: "Immunofluorescence-SpaC_s",
    },
    {
      level: 2,
      text: "Half-Life of SpaC",
      id: "Halflife2-SpaC_s",
    },
    {
      level: 2,
      text: "Mucus binding experiment",
      id: "Mucusbinding-SpaC_s",
    },
    {
      level: 2,
      text: "Immunofluorescence GFP (nanobody version)",
      id: "ImmunofluorescenceGFP-SpaC_s",
    },
    {
      level: 2,
      text: "Shortening of SpaC: D1 & D2 domains",
      id: "Shortening1-SpaC_s",
    },
    {
      level: 2,
      text: "Shortening of SpaC: D2 domain",
      id: "Shortening2-SpaC_s",
    },
    {
      level: 2,
      text: "Primary Culture of BL21 containing shortened SpaC plasmid: D1 & D2 domains",
      id: "Primary5-SpaC_s",
    },
    {
      level: 2,
      text: "Secondary culture of BL21 containing shortened SpaC - D1 & D2 domains",
      id: "Secondary5-SpaC_s",
    },
    {
      level: 2,
      text: "Glycerol stock of BL21 containing shortened SpaC - D1 & D2 domains",
      id: "Glycerol3-SpaC_s",
    },
    {
      level: 2,
      text: "Miniprep of BL21 containing shortened SpaC - D1 & D2 domains",
      id: "Miniprep2-SpaC_s",
    },
    {
      level: 2,
      text: "Transformation of shortened SpaC - D2 domains",
      id: "Transformation2-SpaC_s",
    },
    {
      level: 2,
      text: "Mucus Binding Experiment",
      id: "Mucusbinding2-SpaC_s",
    },
    {
      level: 2,
      text: "Western Blot of shortened SpaC",
      id: "Western-SpaC_s",
    },
    {
      level: 2,
      text: "Test OD Meter",
      id: "Test-OD-Meter_s",
    },
    {
      level: 2,
      text: "Viability Assay",
      id: "Viability-Assay1_s",
    },
    {
      level: 2,
      text: "Western Blot of shortened SpaC",
      id: "Western2-SpaC_s",
    },
    {
      level: 2,
      text: "Viability Assay",
      id: "Viability-Assay2_s",
    },
    {
      level: 2,
      text: "ImmunoFluorescence Experiment",
      id: "Immunofluorescence2-SpaC_s",
    },
    {
      level: 2,
      text: "Viability Assay",
      id: "Viability-Assay3_s",
    },
    {
      level: 2,
      text: "Half-Life experience",
      id: "Halflife3-SpaC_s",
    }

  ];

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextSpaCNotebook />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-3 TOCstyle">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SpaCNotebook;
